<template>
  <div class="box_hd">
    <div class="box_hd_top">
      <span class="box_hd_top_title">{{title}}</span>
      <button class="box_hd_top_btn" @click="quitEdit">退出</button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  export default {
    props: {
      title: {
        type: String,
      }
    },
    data() {
      return {
        quitShow:false,
      }
    },
    methods:{
      quitEdit(){
        window.history.back();
        // this.$router.push('/account/personal/work')
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .box_hd {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background :#fff;
    .box_hd_top {
      height: 66px;
      border-bottom: 1px solid #e9e9e9
      .box_hd_top_title {
        float: left;
        padding-left: 20px;
        height: 66px;
        line-height: 66px;
        font-size: 20px;
        color: #333;
        font-weight: bold;
      }
      .box_hd_top_btn {
        float: right;
        margin: 10px 20px 0 0;
        display: inline-block;
        width: 140px;
        height: 46px;
        line-height: 46px;
        font-size: 16px;
        color: #333;
        border-radius: 4px;
        border: 1px solid #e9e9e9
        box-sizing: border-box
        &.send {
          text-align: left
          text-indent: 53px
          background: url('send.png') no-repeat left 16px center / 22px 22px
        }
      }
    }
    .box_hd_middle {
      height: 58px;
      overflow: hidden
      .box_hd_middle_text {
        font-size: 14px;
        color: #333;
        height: 58px;
        line-height: 58px;
        padding: 0 20px;
      }
      .box_hd_middle_name {
        display: inline-block;
        padding: 0 20px;
        height: 46px;
        line-height: 44px;
        font-size: 14px;
        color: #333;
        border-radius: 4px;
        border: 1px solid #e9e9e9;
        box-sizing: border-box
      }
    }
  }
  .hint-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.3)
    z-index: 1000
    font-size: 0
    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 0;
      vertical-align: middle;
    }
    .quithint {
      display: inline-block;
      padding: 40px 84px 0;
      width: 400px;
      height: 290px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box
      .img-wrapper {
        margin-bottom: 30px;
        height: 50px;
        text-align: center
      }
      .hint-text {
        margin-bottom: 30px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 22px;
      }
      .cancel, .confirm {
        display: inline-block;
        width: 106px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        border-radius: 4px;
      }
      .cancel {
        margin-right: 20px;
        background: #ccc;
      }
      .confirm {
        background: #3399ff;
        &:hover {
          background: #5eaefe
        }
      }
    }
    .sendhint {
      display: inline-block;
      padding: 40px 0 0;
      width: 400px;
      height: 290px;
      vertical-align: middle;
      background-color: #fff;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box
      .img-wrapper {
        margin-bottom: 20px;
        height: 50px;
        text-align: center
      }
      .send-title {
        font-size: 16px;
        color: #333;
        height: 22px;
        line-height: 22px;
        margin-bottom: 10px;
      }
      .hint-text {
        margin: 0 70px 20px;
        font-size: 14px;
        color: #a5a5a5;
        line-height: 22px;
      }
      .back-btn {
        display: inline-block;
        font-size: 15px;
        color: #fff;
        width: 250px;
        height: 36px;
        line-height: 36px;
        background: #3399ff;
        border-radius: 4px;
        &:hover {
          background: #5eaefe
        }
      }
      .cancel, .confirm {
        display: inline-block;
        width: 106px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 15px;
        color: #fff;
        border-radius: 4px;
      }
      .cancel {
        margin-right: 20px;
        background: #ccc;
      }
      .confirm {
        background: #3399ff;
        &:hover {
          background: #5eaefe
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/homework/scheckchattop.vue